// extracted by mini-css-extract-plugin
export var buttonContainer = "_6o-1";
export var fontSizeSelect = "_6o-3";
export var formatSelect = "_6o-2";
export var formats = "_6o-4";
export var hidden = "_6o-5";
export var icon = "_6o-6";
export var select = "_6o-0";